import { Stack, Typography, useTheme } from "@mui/material";
import { Radio } from "components";
import { ReactNode } from "react";

export const RadioItem = ({
  label,
  actionItem,
  onChange,
  isSelected,
}: {
  label: string;
  actionItem?: ReactNode;
  onChange: () => void;
  isSelected: boolean;
}) => {
  const theme = useTheme();
  return (
    <Stack
      direction="row"
      alignItems="flex-start"
      p="16px"
      border={`1px solid ${
        isSelected ? theme.palette.primary.main : theme.palette.neutral["010"]
      }`}
      borderRadius="12px"
      gap="8px"
      sx={{
        cursor: "pointer",
        userSelect: "none",
      }}
      onClick={onChange}
    >
      <Radio
        checked={isSelected}
        disableRipple
        sx={{
          padding: 0,
          margin: 0,
          width: "20px",
          height: "20px",
          "& .MuiTouchRipple-root": {
            display: "none",
          },
          "& .MuiRadio-root": {
            padding: 0,
          },
          pointerEvents: "none",
        }}
      />
      <Stack gap="16px" flex={1}>
        <Typography variant="subtitle1">{label}</Typography>
        {isSelected && actionItem}
      </Stack>
    </Stack>
  );
};
